// extracted by mini-css-extract-plugin
export default {"box":"TopRowBoxIncDecButtons_box__3XrK9","button":"TopRowBoxIncDecButtons_button__qWoPx"};